import React from "react";
import { Link } from "react-router-dom";
import logoImg from "images/logo.png";
import logoLightImg from "images/logo-light.png";
import LogoSvg from "../Logo/LogoSvg"
import { ImageProps } from "types/Image";

export interface LogoProps extends ImageProps {
  img?: string;
  imgLight?: string;
  width?: string;
  height?: string;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({
  img = logoImg,
  imgLight = logoLightImg,
  width = "300",
  height = "50",
  className = "h-10 w-auto object-contain",
  fetchPriority = "high",
  skipLazy = true,
}) => {
  return (
    <Link
      aria-label="DZ Insights - Return to homepage"
      to="/"
      className="ttnc-logo inline-flex items-center flex-shrink-0 text-primary-6000"
    >
      <LogoSvg
        width={width}
        height={height}
        className={className}
        fetchPriority={fetchPriority}
        skipLazy={skipLazy}
      />
    </Link>
  );
};

export default Logo;
